export const en = {
    codes: {
        reasonText: {
            inspectionPassed: 'Inspection passed',
            initialSetup: 'Initial setup',
            occupiedNeedsService: 'Night audit: occupied room needs service',
            nightAuditDate: 'Night audit {{date}}',
            overrideCheck: 'Night audit check {{check}} overridden',
            ticketResolved: 'Maintenance ticket resolved',
            ticket: 'Maintenance ticket: {{text}}',
            maintenance: 'Maintenance: {{text}}',
            transfer: 'Transfer',
            mistake: 'Entry error',
            nonPayment: 'Non-payment',
            unknownBooking: 'Unknown booking',
            noReservation: 'No reservation for this booking',
            expired: 'Expired',
            endedByHotel: 'Ended by the hotel',
            registration: 'Registration',
            guestRequest: 'Guest request',
        },
        level: {
            info: 'Info',
            warning: 'Warning',
            critical: 'Critical',
        },
        actorKind: {
            user: 'User',
            system: 'System',
            cloud_command: 'Cloud command',
            support: 'Support',
            staff: 'Syrova team',
            channel: 'Channels',
            node: 'Hotel server',
            owner: 'Owner',
            tenant_user: 'Portal user',
        },
        status: {
            active: 'Active',
            suspended: 'Suspended',
            closed: 'Closed',
            disabled: 'Disabled',
            provisioned: 'Provisioned',
            retired: 'Retired',
            superseded: 'Superseded',
            revoked: 'Revoked',
            requested: 'Requested',
            approved: 'Approved',
            expired: 'Expired',
            rejected: 'Rejected',
            held: 'Held',
            confirmed: 'Confirmed',
            accepted: 'Accepted',
            cancelled: 'Cancelled',
            open: 'Open',
            in_progress: 'In progress',
            waiting_hotel: 'Waiting hotel',
            resolved: 'Resolved',
            ok: 'Ok',
            failed: 'Failed',
            running: 'Running',
            pending: 'Pending',
        },
        role: {
            staff_admin: 'Operations admin',
            ops: 'Operations',
            support: 'Support',
            sales: 'Sales',
            tenant_admin: 'Admin',
            viewer: 'Viewer',
        },
        releaseKind: {
            release: 'Release',
            hotfix: 'Hotfix',
        },
        releaseChannel: {
            stable: 'Stable',
            beta: 'Beta',
            dev: 'Development',
        },
        auditEntity: {
            app_user: 'App user',
            user: 'User',
            auth: 'Auth',
            approval: 'Approval',
            approval_request: 'Approval request',
            ar: 'Ar',
            business_date: 'Business date',
            cashier_shift: 'Cashier shift',
            channel: 'Channel',
            channel_booking: 'Channel booking',
            charge_code: 'Charge code',
            company_account: 'Company account',
            credit_note: 'Credit note',
            exchange_rate: 'Exchange rate',
            folio: 'Folio',
            folio_line: 'Folio line',
            group: 'Group',
            group_block: 'Group block',
            guest: 'Guest',
            guest_identity_document: 'Guest identity document',
            handover_note: 'Handover note',
            housekeeping: 'Housekeeping',
            housekeeping_task: 'Housekeeping task',
            import: 'Import',
            invoice: 'Invoice',
            invoice_series: 'Invoice series',
            license: 'License',
            maintenance_ticket: 'Maintenance ticket',
            night_audit: 'Night audit',
            night_audit_run: 'Night audit run',
            notification: 'Notification',
            pii: 'Pii',
            property: 'Property',
            rate_plan: 'Rate plan',
            rate_rule: 'Rate rule',
            replay: 'Replay',
            replay_event: 'Replay event',
            reservation: 'Reservation',
            reservation_room: 'Reservation room',
            retention: 'Retention',
            room: 'Room',
            room_type: 'Room type',
            stay: 'Stay',
            support: 'Support',
            support_grant: 'Support grant',
            support_access_grant: 'Support access grant',
            tax: 'Tax',
            directory_user: 'Directory user',
            feature_flags: 'Feature flags',
            maintenance_window: 'Maintenance window',
            node: 'Node',
            onboarding: 'Onboarding',
            onboarding_batch: 'Onboarding batch',
            release: 'Release',
            staff: 'Staff',
            staff_user: 'Staff user',
            tenant: 'Tenant',
            tenant_user: 'Tenant user',
            ticket: 'Ticket',
            wave: 'Wave',
        },
        auditVerb: {
            created: 'created',
            updated: 'updated',
            deleted: 'deleted',
            opened: 'opened',
            closed: 'closed',
            reopened: 'reopened',
            approved: 'approved',
            ended: 'ended',
            requested: 'requested',
            expired: 'expired',
            cancelled: 'cancelled',
            released: 'released',
            posted: 'posted',
            reversed: 'reversed',
            transferred: 'transferred',
            adjusted: 'adjusted',
            applied: 'applied',
            revoked: 'revoked',
            issued: 'issued',
            merged: 'merged',
            anonymized: 'anonymized',
            anonymize_scheduled: 'anonymize scheduled',
            captured: 'captured',
            acknowledged: 'acknowledged',
            assigned: 'assigned',
            distributed: 'distributed',
            flagged: 'flagged',
            generated: 'generated',
            completed: 'completed',
            started: 'started',
            override: 'override',
            accessed: 'accessed',
            settings_changed: 'settings changed',
            status_changed: 'status changed',
            checked_in: 'checked in',
            checked_out: 'checked out',
            room_moved: 'room moved',
            extended: 'extended',
            shortened: 'shortened',
            auto_extended: 'auto extended',
            check_in_undone: 'check in undone',
            carried: 'carried',
            rolled: 'rolled',
            reclaimed: 'reclaimed',
            dismissed: 'dismissed',
            modified: 'modified',
            unassigned: 'unassigned',
            no_show: 'no show',
            confirmed: 'confirmed',
            hold: 'hold',
            rejected: 'rejected',
            node_rejected: 'node rejected',
            done: 'done',
            in_progress: 'in progress',
            inspected: 'inspected',
            provisioned: 'provisioned',
            activated: 'activated',
            retired: 'retired',
            batch_imported: 'batch imported',
            published: 'published',
            withdrawn: 'withdrawn',
            rollout_set: 'rollout set',
            auto_paused: 'auto paused',
            snapshot: 'snapshot',
            disabled_from_cloud: 'disabled from cloud',
            lines_transferred: 'lines transferred',
            window_opened: 'window opened',
            discount_posted: 'discount posted',
            transferred_to_ar: 'transferred to ar',
            master_folio_opened: 'master folio opened',
            rooming_list: 'rooming list',
            discrepancy_noted: 'discrepancy noted',
            discrepancy_resolved: 'discrepancy resolved',
            identity_documents_wiped: 'identity documents wiped',
            set: 'set',
            status: 'status',
            guests: 'guests',
            rooms: 'rooms',
            channel_settings: 'channel settings',
        },
        auditAction: {
            'auth.login': 'Sign in',
            'auth.logout': 'Sign out',
            'auth.mfa_enabled': 'Two-step verification on',
            'auth.mfa_disabled': 'Two-step verification off',
            'auth.mfa_failed': 'Wrong verification code',
            'auth.mfa_recovery_used': 'Recovery code used',
            'auth.mfa_throttled': 'Verification attempts paused',
            'auth.password_changed': 'Password changed',
            'auth.pin_set': 'PIN set',
            'auth.reauth': 'Re-authentication',
            'auth.reauth_failed': 'Re-authentication failed',
            'pii.accessed': 'Personal data viewed',
            'import.guests': 'Guests imported',
            'import.rooms': 'Rooms imported',
            'business_date.rolled': 'Business date advanced',
        },
        lineType: {
            charge: 'Charge',
            service_charge: 'Service charge',
            tax: 'Tax',
            discount: 'Discount',
            payment: 'Payment',
            change: 'Change',
            deposit: 'Deposit',
            refund: 'Refund',
            rounding: 'Rounding',
            fx_difference: 'FX difference',
        },
        revenueGroup: {
            room: 'Rooms',
            f_and_b: 'Food & beverage',
            laundry: 'Laundry',
            minibar: 'Minibar',
            phone: 'Phone',
            misc: 'Miscellaneous',
            package: 'Packages',
            fee: 'Fees',
            system: 'System',
        },
        paymentMethod: {
            cash: 'Cash',
            card: 'Card',
            bank_transfer: 'Bank transfer',
            other: 'Other',
            city_ledger: 'Company account',
        },
        invoiceKind: { final: 'Final invoice', proforma: 'Proforma', credit_note: 'Credit note' },
        shiftStatus: { open: 'Open', closed: 'Closed' },
        noteKind: {
            guest_request: 'Guest request',
            internal: 'Internal',
            housekeeping: 'Housekeeping',
            billing: 'Billing',
        },
        taxKind: {
            percentage: 'Percentage',
            fixed_per_night: 'Fixed per night',
            fixed_per_stay: 'Fixed per stay',
            service_charge: 'Service charge',
        },
        lineSource: {
            manual: 'Manual',
            night_audit: 'Night audit',
            system: 'System',
            pos: 'POS',
            transfer: 'Transfer',
        },
    },
    app: { name: 'Syrova', tagline: 'The hotel operating system' },
    common: {
        viewAll: 'View all',
        all: 'All',
        previous: 'Previous',
        next: 'Next',
        type: 'Type',
        resultsCount: '{{n}} results',
        saved: 'Saved',
        open: 'Open',
        save: 'Save',
        cancel: 'Cancel',
        close: 'Close',
        confirm: 'Confirm',
        back: 'Back',
        search: 'Search',
        loading: 'Loading…',
        yes: 'Yes',
        no: 'No',
        required: 'This field is required',
        none: 'None',
        print: 'Print',
        actions: 'Actions',
        reason: 'Reason',
        notes: 'Notes',
        adults: 'Adults',
        children: 'Children',
        nights: 'Nights',
        total: 'Total',
        date: 'Date',
        from: 'From',
        to: 'To',
        today: 'Today',
        new: 'New',
        edit: 'Edit',
        details: 'Details',
        noResults: 'No results',
        retry: 'Retry',
        optional: 'optional',
    },
    nav: {
        frontDesk: 'Front desk',
        dashboard: 'Dashboard',
        arrivals: 'Arrivals',
        departures: 'Departures',
        inHouse: 'In-house',
        walkIn: 'Walk-in',
        reservations: 'Reservations',
        newReservation: 'New reservation',
        tapeChart: 'Tape chart',
        guests: 'Guests',
        cashier: 'Cashier',
        housekeeping: 'Housekeeping',
        reports: 'Reports',
        nightAudit: 'Night audit',
        admin: 'Admin',
        comingSoon: 'Coming soon',
        theme: 'Dark mode',
        groupFinance: 'Finance',
        groupOperations: 'Operations',
        groupReports: 'Reports & insights',
        groupAdmin: 'Administration',
        collapse: 'Collapse menu',
        expand: 'Expand menu',
        language: 'العربية',
        themeLight: 'Light mode',
        search: 'Search',
    },
    auth: {
        login: 'Sign in',
        logout: 'Sign out',
        username: 'Username',
        password: 'Password',
        pin: 'PIN',
        enterPin: 'Enter your PIN to continue',
        invalidCredentials: 'Incorrect username or password',
        accountLocked: 'Account temporarily locked after repeated failures. Try again in {{wait}}.',
        mustChangePassword: 'You must change your password before continuing',
        sessionExpired: 'Your session expired. Please sign in again.',
        lockScreen: 'Lock screen',
        locked: 'Screen locked',
        unlock: 'Unlock',
        invalidPin: 'Invalid PIN',
        pinNotSet: 'No PIN is set for this user',
        pinSetupTitle: 'Set your PIN',
        pinSetupHint: 'Money operations need a 4–6 digit PIN. Enter your password and choose a PIN; from now on it confirms these operations instead of your password.',
        newPin: 'New PIN (4–6 digits)',
        pinFormat: 'The PIN is 4 to 6 digits',
    },
    status: {
        businessDate: 'Business date',
        shift: 'Shift',
        shiftOpen: 'Shift open',
        shiftClosed: 'No open shift',
        shiftOpenSince: 'Shift open since {{time}}',
        sync: 'Sync',
        syncOk: 'Synced',
        syncDelayed: 'Sync delayed for {{age}}',
        syncOffline: 'No cloud connection for {{age}}',
        power: 'Power',
        onBattery: 'On battery ({{minutes}} min left)',
        nodeUnreachable: 'Cannot reach the hotel server. Check the network and retry.',
        nodeRecovering: 'The server is recovering after a power loss. Please wait…',
    },
    health: {
        msg: {
            backupCompleted: 'Backup completed',
            backupFailed: 'Backup failed',
            drillPassed: 'Restore drill passed',
            drillFailed: 'Restore drill failed',
            resumedUnclean: 'Resumed after an unclean shutdown',
            nodeActivated: 'Hotel server activated with the cloud',
            licenseApplied: 'License applied from the cloud',
            licenseRevoked: 'License revoked by the cloud',
            channelBooking: 'Channel booking → {{ref}}',
            updated: 'Updated to {{v}}',
            agentStopping: 'Agent stopping',
            updateRolledBack: 'Update to {{v}} rolled back',
            updateFailed: 'Update to {{v}} failed before switching',
            manifestRejected: 'Update manifest rejected',
            supportSnapshotFailed: 'Support snapshot failed',
            supportRequest: 'Syrova support requests {{scope}} access (ticket {{ticket}})',
            commandRejected: 'Cloud command rejected ({{cmd}})',
            clockBehind: 'Server clock is behind the last recorded event',
            diskCritical: 'Disk almost full — free space now',
            replayImport: 'Restore event import',
            cloudKeysMissing: 'Cloud verification keys are not set',
            agentVersion: 'agent {{v}}',
            megabytes: '{{n}} MB',
        },
        title: 'System health',
        navLabel: 'System health',
        agentStale: 'The node agent has not reported for {{age}}. Check the syrova-agent service.',
        agentNever: 'The node agent has not reported yet.',
        updatedAt: 'Last reading',
        cards: {
            postgres: 'Database',
            api: 'Application server',
            disk: 'Data disk',
            backupDisk: 'Backup disk (USB)',
            backup: 'Last backup',
            drill: 'Last restore drill',
            outbox: 'Events awaiting sync',
            sync: 'Last cloud contact',
            power: 'Power',
            clock: 'Clock',
            unclean: 'Unclean shutdowns (7 days)',
            boot: 'Boot to ready',
            version: 'Version',
        },
        values: {
            up: 'running',
            down: 'down',
            recovering: 'recovering',
            ready: 'ready',
            notReady: 'not ready',
            free: '{{pct}}% free ({{gb}} GB)',
            missing: 'not connected',
            readOnly: 'not writable',
            never: 'never run',
            ok: 'passed',
            failed: 'failed',
            notConfigured: 'not configured',
            mains: 'mains power',
            battery: 'on battery ({{pct}}%)',
            noBattery: 'no battery/UPS detected',
            clockOk: 'sane',
            clockAnomaly: 'Clock is behind the last recorded event!',
            seconds: '{{s}} s',
            events: '{{n}}',
            schema: 'schema {{v}}',
        },
        actions: {
            backupNow: 'Back up now',
            drillNow: 'Restore drill now',
            started: 'Started. The result appears in the log within minutes.',
        },
        upsHint: 'A UPS is recommended for this PC: a power cut means an unclean restart. Committed data is protected; a UPS protects work in progress.',
        thresholds: 'Alert thresholds: disk < 20% warning, < 10% critical; backup older than 8 h; backup disk missing > 24 h critical; restore drill older than 8 days.',
        log: 'Recent operations',
        backups: 'Backups',
        replay: {
            title: 'Cloud replay reconciliation',
            hint: 'Events imported from the cloud after restoring a backup: "missing" = never recorded locally, to be re-entered by hand and closed with a note.',
            missing: 'missing',
            present: 'present',
            dismissed: 'closed',
            lastImport: 'Last import',
            none: 'Nothing imported yet. On the restored node: syrova-agent replay-import --cloud',
            dismiss: 'Close',
            dismissNote: 'What was re-entered, or why it is skipped?',
            byType: 'By type',
            payload: 'Payload',
        },
        cols: {
            when: 'When',
            kind: 'Kind',
            level: 'Level',
            message: 'Message',
            size: 'Size',
            status: 'Status',
            verified: 'Restore drill',
            location: 'File',
        },
        kinds: {
            cloud: 'Cloud',
            replay: 'Event import',
            sync: 'Sync',
            support: 'Support',
            update: 'Update',
            release: 'Release',
            boot: 'boot',
            stop: 'stop',
            unclean_shutdown: 'unclean shutdown',
            self_check: 'self-check',
            backup: 'backup',
            restore_drill: 'restore drill',
            clock_anomaly: 'clock anomaly',
            power: 'power',
            disk: 'disk',
        },
        alerts: {
            AGENT_DOWN: 'Node agent not responding',
            PG_DOWN: 'Database is down',
            PG_RECOVERING: 'Database is recovering',
            API_DOWN: 'Application server not ready',
            DISK_LOW: 'Disk space low ({{value}}%)',
            DISK_CRITICAL: 'Disk space critical ({{value}}%) — free space now',
            BACKUP_NOT_CONFIGURED: 'Backups are not configured',
            BACKUP_TARGET_MISSING: 'Backup disk not connected for {{age}}',
            BACKUP_TARGET_MISSING_NEW: 'Backup disk not connected',
            BACKUP_DISK_FULL: 'Backup disk almost full',
            BACKUP_STALE: 'No successful backup for {{age}}',
            BACKUP_NEVER: 'No backup has been taken yet',
            BACKUP_FAILED: 'Last backup failed',
            DRILL_FAILED: 'Restore drill failed — backups may be unusable',
            DRILL_STALE: 'No restore drill for more than a week',
            OUTBOX_BACKLOG: 'Sync backlog growing ({{value}})',
            CLOCK_ANOMALY: 'System clock is wrong — fix it before continuing',
            UNCLEAN_SHUTDOWNS: 'Repeated power cuts ({{value}} in 7 days) — check the UPS',
            POWER_BATTERY: 'Running on battery',
            POWER_LOW: 'Battery low ({{value}}%)',
            POWER_CRITICAL: 'Battery critical ({{value}}%) — save your work; the system will shut down',
            UPS_RECOMMENDED: 'No UPS detected (recommended)',
        },
        bannerLink: 'Details',
    },
    boot: {
        title: 'The hotel server is starting…',
        hint: 'Wait about two minutes. This page refreshes every 5 seconds.',
        unreachable: 'Cannot reach the hotel server. Check its power and the network switch, then retry. The printed card has the fallback IP address.',
        lastKnown: 'Last known state: business date {{date}}, last operation {{time}}',
        checks: {
            postgres: 'Database',
            api: 'Application server',
            disk: 'Disk',
            backup: 'Backup',
            power: 'Power',
            clock: 'Clock',
        },
        pending: 'checking',
    },
    resume: {
        title: 'The system came back after an outage at {{time}}.',
        titleClean: 'The system was restarted at {{time}}.',
        lastSaved: 'No committed data was lost: last saved operation {{time}} ({{action}}).',
        noSaved: 'No operations recorded before the outage.',
        formsLost: 'Forms that were being typed in the browser and not submitted were not saved — check what you were doing.',
        openShift: "{{user}}'s shift open since {{time}}",
        audit: 'Night audit for {{date}} incomplete ({{status}})',
        outbox: '{{n}} events awaiting sync',
        dismiss: 'Got it',
    },
    license: {
        title: 'License',
        stage: 'Status',
        expiresAt: 'Expires',
        perpetual: 'Perpetual — no expiry',
        daysLeft: '{{days}} left',
        daysOver: 'expired {{days}} ago',
        plan: 'Plan',
        roomCap: 'room cap: {{n}}',
        node: 'Device fingerprint',
        noIdentity: 'The node agent has not created the device identity yet',
        activated: 'activated with the cloud on {{at}}',
        notActivated: 'not activated with the cloud (local only)',
        ladderHint: 'Check-out, payments and data export are never blocked, whatever the license state.',
        applyTitle: 'Apply a license offline',
        applyHint: 'Paste the signed license file Syrova sent (JSON: document, signature, keyId). The signature and this device fingerprint are verified before it is applied.',
        pasteLabel: 'License file',
        applyButton: 'Apply license',
        applied: 'License applied',
        alreadyCurrent: 'This license is already applied',
        invalidJson: 'The text is not valid JSON',
        stages: {
            none: 'not activated',
            ok: 'valid',
            pre_expiry: 'expiring soon',
            warning: 'expired — warning period',
            degraded: 'expired — settings frozen',
            floor: 'expired — read-only',
            not_yet_valid: 'not yet valid',
        },
        banner: {
            none: 'This server is not linked to Syrova yet: activate it with a code, or apply a license file on the License screen.',
            pending: 'The server is activated and its license is on its way from the Syrova cloud: it arrives within minutes while the internet is up.',
            preExpiry: 'The license expires in {{days}}. Contact Syrova to renew.',
            warning: 'The license expired {{days}} ago. Everything still works; renew before settings get restricted.',
            degraded: 'License expired: settings are read-only. Check-in/out, payments and reservations keep working.',
            floor: 'License expired or revoked: read-only except check-out, payments and export. Contact Syrova.',
            notYetValid: 'The applied license is not valid yet.',
        },
    },
    cloud: {
        adminName: 'Syrova — Ops console',
        adminSub: 'Operations console',
        portalSub: 'Owner portal',
        portalName: 'Syrova — Owner portal',
        email: 'Email',
        logout: 'Log out',
        nav: {
            tenants: 'Tenants',
            fleet: 'Fleet',
            grants: 'Support access',
            properties: 'My properties',
            reports: 'Reports',
            audit: 'Audit',
        },
        tenants: {
            title: 'Tenants',
            new: 'New tenant',
            code: 'Code',
            nameAr: 'Name',
            nameEn: 'English name',
            contact: 'Contact email',
            properties: 'Properties',
            created: 'Tenant created',
        },
        tenant: {
            newProperty: 'New property',
            roomCap: 'Room cap',
            timezone: 'Timezone',
            currency: 'Base currency',
            portalUsers: 'Portal users',
            newPortalUser: 'New portal user',
            directory: 'Staff directory',
            newDirectoryUser: 'New staff user',
            username: 'Username',
            displayName: 'Display name',
            password: 'Password',
            role: 'Role',
            assignTo: 'Property',
            roleCode: 'Role code on the node',
            audit: 'Action log',
        },
        property: {
            node: 'Node',
            noNode: 'No node yet',
            provision: 'Provision node (activation code)',
            activationCode: 'Activation code (shown once)',
            activationHint: 'On the hotel server: node-agent activate --url {{url}} --code {{code}} — valid until {{expires}}',
            retire: 'Retire node',
            retireReason: 'Retire reason',
            status: { provisioned: 'awaiting activation', active: 'active', retired: 'retired' },
            lastSeen: 'Last seen',
            never: 'never connected',
            license: 'License',
            noLicense: 'No license',
            issue: 'Issue license',
            planCode: 'Plan code',
            expiresAt: 'Expires at',
            perpetualHint: 'Leave empty for a perpetual license (the product is free)',
            modules: 'Modules (comma separated)',
            revoke: 'Revoke',
            revokeReason: 'Revoke reason',
            issued: 'License issued and queued for the node',
            flags: 'Feature flags (JSON)',
            saveFlags: 'Save flags',
            window: 'Maintenance window',
            dayOfWeek: 'Day',
            startTime: 'Start',
            duration: 'Duration (minutes)',
            saveWindow: 'Save window',
            commands: 'Recent commands',
            backups: 'Reported backups',
            days: {
                d0: 'Sunday',
                d1: 'Monday',
                d2: 'Tuesday',
                d3: 'Wednesday',
                d4: 'Thursday',
                d5: 'Friday',
                d6: 'Saturday',
            },
        },
        fleet: {
            title: 'Fleet',
            tenant: 'Tenant',
            property: 'Property',
            version: 'Version',
            schema: 'Schema',
            seen: 'Last seen',
            minutesAgo: '{{n}} min ago',
            stage: 'License',
            backup: 'Last backup',
            alerts: 'Alerts',
            pending: 'Pending commands',
        },
        grants: {
            snapshots: 'Session snapshots',
            lastActivity: 'Last activity',
            noSnapshots: 'No snapshots yet',
            view: 'View',
            close: 'Close',
            anchors: 'Audit anchors',
            title: 'Support access requests',
            request: 'Request access',
            property: 'Property',
            scope: 'Scope',
            reason: 'Reason',
            ticket: 'Ticket',
            duration: 'Duration (minutes)',
            status: 'Status',
            requested: 'Access request sent to the owner',
            approve: 'Approve',
            reject: 'Reject',
            decided: 'Decision recorded',
            scopes: { readonly_ops: 'read-only', diagnostics: 'diagnostics', full: 'full' },
            statuses: {
                requested: 'awaiting approval',
                approved: 'approved',
                active: 'active',
                expired: 'expired',
                revoked: 'revoked',
                rejected: 'rejected',
            },
            portalHint: 'Syrova requests to access your hotel node. No access without your approval; every action is recorded.',
        },
        mfa: {
            code: 'Authenticator code (or recovery code)',
            required: 'Enter your authenticator code',
            enrolTitle: 'Enable two-step verification to continue',
            enrolHint: 'Mandatory for Syrova accounts and tenant admins. It takes a minute.',
            secret: 'Key',
            stepApp: 'Install an authenticator app on your phone, such as Google Authenticator or Microsoft Authenticator.',
            stepScan: 'Open the app and scan this code.',
            qrLabel: 'QR code that adds this account to your authenticator app',
            manual: "Can't scan? Enter the key manually",
            copy: 'Copy',
            copied: 'Copied',
            stepCode: 'Enter the 6-digit code shown in the app.',
            confirm: 'Confirm',
            recovery: 'Recovery codes (shown once)',
            recoveryHint: 'Keep them somewhere safe, off this device. Each code signs you in once if you lose your phone.',
            copyAll: 'Copy codes',
            continue: 'Continue',
        },
        tickets: {
            title: 'Tickets',
            nav: 'Tickets',
            portalNav: 'Support',
            new: 'New ticket',
            subject: 'Subject',
            body: 'Details',
            severity: 'Severity',
            status: 'Status',
            property: 'Property',
            updated: 'Updated',
            assign: 'Assign to me',
            comment: 'Reply',
            send: 'Send',
            showAll: 'Show closed too',
            created: 'Ticket opened',
            empty: 'No open tickets',
            severities: { low: 'low', normal: 'normal', high: 'high', critical: 'critical' },
            statuses: {
                open: 'open',
                in_progress: 'in progress',
                waiting_hotel: 'waiting for hotel',
                resolved: 'resolved',
                closed: 'closed',
            },
            setStatus: 'Set status',
            portalHint: 'Open a ticket for any issue; the Syrova team answers here and on the support line. No guest data in tickets.',
        },
        rollout: {
            nav: 'National rollout',
            title: 'National rollout — waves and indicators',
            waves: 'Waves',
            wavesHint: 'Pausing a wave only blocks new node activations in it; installed hotels keep running (one kill switch per wave).',
            wave: 'Wave',
            properties: 'installed / registered',
            propertiesCount: 'Properties',
            installs: 'Installs',
            paused: 'paused',
            running: 'running',
            pause: 'Pause installs',
            resume: 'Resume',
            pauseReason: 'Reason for the pause',
            weekly: 'Weekly steering report',
            weeklyLine: '{{installed}} installed this week (total {{total}}) · stalled > 24h: {{stalled}} · critical alerts: {{critical}} · tickets: {{opened}} opened, {{resolved}} resolved, {{open}} open · {{reservations}} reservations, {{checkIns}} check-ins, {{audits}} night audits · {{updates}} updates ({{rolledBack}} rolled back)',
            kpi: {
                coverage: 'Coverage (installed/registered)',
                active60d: 'Active in the last 7 days',
                stalled: 'Stalled > 24 h',
                ticketP50: 'Ticket resolution p50 (hours)',
                doubleBookings: 'Double bookings',
            },
            ministry: 'Ministry view (aggregated by governorate)',
            ministryHint: 'Aggregates only, no hotel or guest names; occupancy is suppressed below 5 reporting hotels (k-anonymity, T-07).',
            csv: 'Download CSV',
            governorate: 'Governorate',
            rooms: 'Rooms',
            installed: 'Installed',
            active7d: 'Active (7 days)',
            occupancy: 'Occupancy',
            suppressed: 'suppressed (<5)',
            totals: 'Total: {{properties}} properties · {{installed}} installed · {{active}} active · occupancy {{occupancy}}',
        },
        onboarding: {
            title: 'Bulk onboarding',
            nav: 'Onboarding',
            hint: 'Paste a CSV from the facilities registry: tenant_code,tenant_name_ar,property_code,property_name_ar,room_cap[,governorate][,category][,wave][,owner_email][,contact_email]. Each row creates the property, a node with a one-time activation code and, when an owner email is given, a portal owner with a temporary password. Print the sheets now: codes are never shown again.',
            run: 'Onboard',
            result: '{{props}} properties created ({{tenants}} new tenants), {{errors}} errors',
            sheets: 'Activation sheets',
            print: 'Print sheets',
            sheetTitle: 'Syrova activation sheet',
            code: 'Activation code',
            expires: 'Valid until',
            owner: 'Portal account',
            tempPassword: 'Temporary password (change on first sign-in)',
            steps: 'Steps: 1) run the installer on the hotel PC 2) enter the activation code when asked 3) open https://<pc-name>.local and finish the setup wizard.',
            errors: 'Errors',
        },
        channels: {
            guestPending: 'Awaiting guest details',
            nav: 'Channels',
            title: 'Channels & online bookings',
            partners: 'Partners',
            newChannel: 'New channel',
            code: 'Code',
            name: 'Name',
            rateLimit: 'Requests / minute',
            bookings: 'bookings',
            status: 'Status',
            suspend: 'Suspend',
            activate: 'Activate',
            keyOnce: 'API key — shown once only, copy it now:',
            propertySlug: 'Booking page link (slug)',
            saveSlug: 'Save',
            bookingsTitle: 'Online bookings',
            unsettled: 'unsettled (not at the hotel yet)',
            all: 'All',
            mode: { instant: 'instant', requested: 'request' },
            statuses: {
                held: 'held',
                confirmed: 'confirmed',
                requested: 'requested',
                accepted: 'accepted',
                rejected: 'rejected',
                cancelled: 'cancelled',
                expired: 'expired',
            },
            hotelRef: 'Hotel ref',
            applied: 'at the hotel',
            notApplied: 'not yet',
            redelivered: 'redelivered {{n}}',
            decideAccept: 'Accept',
            decideReject: 'Reject',
            cancel: 'Cancel',
            pendingNode: 'Decision sent to the hotel; closes when its event arrives',
        },
        portal: {
            properties: 'My properties',
            connected: 'connected',
            stale: 'offline for {{n}} min',
            offline: 'no connection',
            businessDate: 'Business date',
            occupancy: 'Occupancy',
            inHouse: 'In house',
            arrivals: 'Arrivals today',
            departures: 'Departures today',
            backup: 'Last backup',
            drillOk: 'restore drill passed',
            drillFailed: 'restore drill failed',
            reports: 'Daily summary from the nodes (anonymised — no guest names)',
            noData: 'No data yet; it appears after the node first connects.',
            summary: 'Property summary (last {{days}} days)',
            roomCap: 'Rooms',
            avgOccupancy: 'Avg occupancy',
            nightAudits: 'Night audits / days',
            shareWhatsapp: 'Share summary on WhatsApp',
            totals: 'Totals: properties · rooms · occupancy · in house · arrivals · reservations · invoices · night audits',
        },
        releases: {
            title: 'Releases',
            publish: 'Publish a signed manifest',
            publishHint: 'Paste manifest.json after two signers signed it (scripts/release). The registry re-verifies the signatures.',
            published: 'Release published',
            version: 'Version',
            channel: 'Channel',
            rollout: 'Rollout %',
            attempted: 'Attempted',
            done: 'Done',
            failed: 'Failed',
            paused: 'Auto-paused',
            withdrawn: 'Withdrawn',
            setRollout: 'Set rollout',
            withdraw: 'Withdraw (kill switch)',
            withdrawReason: 'Withdraw reason',
            fleetVersions: 'Fleet version distribution',
            sync: 'Sync',
        },
        stages: {
            none: 'no license',
            ok: 'valid',
            pre_expiry: 'expiring soon',
            warning: 'expired (warning)',
            degraded: 'degraded',
            floor: 'read-only',
            not_yet_valid: 'not yet valid',
        },
    },
    security: {
        title: 'Security & privacy',
        navLabel: 'Security',
        mfa: {
            title: 'Two-step verification (authenticator app)',
            hint: 'A code from an authenticator app (Aegis, Google Authenticator…) that works offline. Recommended for managers.',
            enabled: 'Enabled',
            disabled: 'Not enabled',
            enable: 'Enable',
            disable: 'Disable',
            secret: 'Key (manual entry)',
            uriHint: 'Scan the link or type the key into the app, then enter the code it shows to confirm.',
            code: 'Verification code (6 digits)',
            confirm: 'Confirm',
            recoveryTitle: 'Recovery codes — print and store them now',
            recoveryHint: 'Each code works once if you lose your phone. They will not be shown again.',
            done: 'Two-step verification enabled',
            disabledToast: 'Two-step verification disabled',
            passwordToDisable: 'Enter your password to disable',
            loginTitle: 'Second step',
            loginHint: 'Enter the code from your authenticator app or one of your recovery codes.',
            invalid: 'Code not accepted',
            expired: 'The second step timed out. Sign in again.',
            enrolRequired: 'Your account must enrol two-step verification before continuing.',
        },
        support: {
            title: 'Support access',
            hint: 'Syrova requests to access this server. Nothing happens without your PIN approval; read-only over an outbound channel, every action is logged.',
            none: 'No requests',
            requestedBy: 'Requested by',
            scope: 'Scope',
            reason: 'Reason',
            status: 'Status',
            window: 'Window',
            activity: 'Session activity',
            activityCount: '{{n}} snapshots',
            approve: 'Approve (PIN)',
            reject: 'Reject',
            end: 'End now',
            approved: 'Approved; read-only snapshots are sent during the window',
            rejected: 'Request rejected',
            ended: 'Session ended',
            scopes: { readonly_ops: 'read-only', diagnostics: 'diagnostics', full: 'full' },
            statuses: {
                requested: 'awaiting approval',
                approved: 'approved',
                active: 'active',
                expired: 'expired',
                revoked: 'ended',
                rejected: 'rejected',
            },
        },
        retention: {
            title: 'Data retention & anonymisation',
            hint: 'These defaults need local legal review. The job runs daily on the server, offline.',
            identityDocumentMonths: 'Wipe identity documents after (months since last departure)',
            guestProfileMonths: 'Anonymise profiles after (months without a stay)',
            minFinancialYears: 'Minimum financial retention (years)',
            runNow: 'Run now',
            lastRun: 'Last run',
            lastRunSummary: '{{docs}} documents wiped · {{guests}} profiles anonymised · {{scheduled}} deferred',
            saved: 'Retention settings saved',
            ran: 'Retention job ran',
        },
        anchors: {
            title: 'Audit log anchors',
            hint: 'The audit chain fingerprint at each day close. Printed on the daily pack and sent to the cloud; a later disk tamper breaks the match.',
            date: 'Business date',
            hash: 'Fingerprint',
            count: 'Events',
            onPack: 'Audit log anchor',
        },
    },
    wizard: {
        title: 'Hotel setup (Lite mode)',
        hint: 'Four offline steps: hotel name, room types, rooms and rates, then start working. Everything can be refined later from the setup screens.',
        step1: 'Hotel',
        step2: 'Room types',
        step3: 'Rooms & rates',
        step4: 'Ready',
        propertyName: 'Hotel name',
        currency: 'Base currency',
        next: 'Next',
        back: 'Back',
        typesHint: 'Enter how many rooms of each type you have (leave 0 for none). The first number generates the rest.',
        typeName: 'Type',
        occupancy: 'Occupancy',
        count: 'Count',
        firstNumber: 'First number',
        price: 'Price/night',
        reviewHint: 'This will be created now:',
        fromNumber: 'from {{n}}',
        roomCount: 'Rooms',
        propertyNameEn: 'English name (optional, printed under the Arabic name)',
        roomsReady: 'Rooms are clean and ready for guests',
        roomNumbers: 'Numbers',
        create: 'Create rooms',
        csvTitle: 'Or: import from Excel (CSV)',
        csvHint: 'Download the template, fill it in Excel, save as CSV (UTF-8) and paste its content here.',
        roomsTemplate: 'Rooms template',
        guestsTemplate: 'Guests template',
        csvPaste: 'CSV content',
        importRooms: 'Import rooms',
        imported: 'Rooms imported: {{n}} · errors: {{errors}}',
        doneTitle: 'The hotel is ready',
        doneSummary: 'Room types: {{types}} · Rooms: {{rooms}} · Rates: {{rates}}',
        doneNext: 'Next: add front-desk users and a PIN from the Security screen, then open the tape chart.',
        openTapeChart: 'Open tape chart',
        openSecurity: 'Security',
    },
    ar: {
        title: 'Accounts receivable (company accounts)',
        navLabel: 'Company accounts',
        accounts: 'Accounts',
        aging: 'Ageing',
        newAccount: 'New company account',
        editAccount: 'Edit company account',
        code: 'Code',
        company: 'Company',
        nameEn: 'Name (Latin)',
        contact: 'Contact',
        address: 'Address',
        creditLimit: 'Credit limit',
        terms: 'Payment terms',
        days: 'days',
        status: 'Status',
        statuses: { active: 'active', suspended: 'suspended', closed: 'closed' },
        pickAccount: 'Pick an account to see its statement',
        openInvoices: 'Open invoices',
        noOpenInvoices: 'No open invoices',
        due: 'Due',
        open: 'Open',
        statement: 'Statement',
        type: 'Type',
        types: {
            invoice: 'Invoice',
            payment: 'Payment',
            credit_note: 'Credit note',
            adjustment: 'Adjustment',
        },
        reference: 'Reference',
        running: 'Running balance',
        collect: 'Collect',
        collectHint: 'The payment is recorded in your open shift and allocated to the oldest invoices first.',
        buckets: { current: 'Not due', d30: '1–30', d60: '31–60', d90: '61–90', over90: '> 90' },
        openTotal: 'Open total',
        transferTitle: 'Transfer to a company account',
        transferHint: 'A final invoice is issued in the company name and the folio is zeroed by a city-ledger line. PIN required.',
        transfer: 'Transfer',
        overrideLimit: 'Override the credit limit (reason required)',
    },
    group: {
        title: 'Group reservations',
        navLabel: 'Groups',
        new: 'New block',
        name: 'Group name',
        cutoff: 'Cut-off date',
        pickup: 'picked up / blocked',
        blocked: 'Blocked',
        pickedUp: 'Picked up',
        remaining: 'Remaining',
        pick: 'Pick a block to see its rooming list',
        statuses: { active: 'active', released: 'released', cancelled: 'cancelled' },
        roomingList: 'Rooming list',
        noNames: 'No names yet — add guests above',
        addName: 'Add name',
        release: 'Release unpicked',
        cancel: 'Cancel block',
        cancelReason: 'Reason for cancelling the block (picked-up reservations stay)',
        routing: 'Routing',
        routingNone: 'Each room on its guest folio',
        routingRoom: 'Room nights to the master folio',
        masterFolio: 'Master folio',
        openMaster: 'Open master folio',
        checkIn: 'Group check-in',
        checkInDone: '{{ok}} checked in · {{failed}} failed',
    },
    forecast: {
        title: 'Forecast',
        navLabel: 'Forecast',
        tag: 'forecast — not actuals',
        days: 'Days',
        weight: 'Tentative weight',
        hint: 'OTB = confirmed + tentative × weight. Pick-up = average rooms added for the same weekday over the last {{weeks}} weeks. Revenue = forecast rooms × ADR from booked rates.',
        sellable: 'Sellable',
        otb: 'On the books',
        pickup: 'Pick-up',
        rooms: 'Forecast rooms',
        weeks: 'Pick-up weeks',
        saveDefaults: 'Save as property defaults',
    },
    channels: {
        title: 'Channels & online booking',
        navLabel: 'Channels',
        disabled: 'off',
        leaseActive: 'connected — instant confirmation',
        leaseExpired: 'lease expired — requests only',
        delegatedUnits: 'delegated to channels: {{n}}',
        pendingUnits: 'pending arrival: {{n}}',
        lastPush: 'last push',
        requests: 'Booking requests',
        requestsHint: 'A request arrives when the delegated budget does not cover the stay or the link is down. Accepting re-checks availability; an unanswered request expires by itself.',
        noRequests: 'No open requests',
        deadline: 'Deadline',
        channel: 'Channel',
        accept: 'Accept',
        reject: 'Reject',
        accepted: 'Accepted — now a confirmed reservation',
        rejected: 'Request rejected',
        rejectReason: 'Reason (optional)',
        delegation: 'Delegation',
        delegationHint: 'Remaining = what the cloud may sell instantly; pending = sold, command not here yet. The desk sees availability minus both. "Reclaim" zeroes the budget for 15 minutes.',
        free: 'Free',
        remaining: 'Remaining for channels',
        pending: 'Pending arrival',
        desired: 'Desired',
        price: 'Price',
        reclaim: 'Reclaim from channels',
        reclaimed: 'The budget is reclaimed within seconds',
        reclaimedUntil: 'reclaimed until {{t}}',
        settings: 'Settings',
        settingsHint: 'the last room stays with the desk and the channel share never exceeds the set percentage per type. Published prices come from the chosen rate plan.',
        enable: 'Publish availability and rates to channels (instant confirmation within the budget)',
        maxShare: 'Max delegation %',
        keepLocal: 'Keep one room local when free ≤',
        sameDayUntil: 'Same-day instant until hour',
        requestTtl: 'Request deadline (minutes)',
        horizon: 'Publish horizon (days)',
        contactPhone: 'Hotel phone (WhatsApp)',
    },
    update: {
        title: 'System updates',
        current: 'Current version',
        available: 'Update {{version}} is ready',
        none: 'No update available. The agent checks the channel every 6 hours.',
        scheduled: 'Installs in the maintenance window (no night audit running, verified backup, not on battery).',
        applyNow: 'Install now',
        applyConfirm: 'The system pauses for a few minutes during the install. No night audit running? Do not power off the server. Continue?',
        defer: 'Defer',
        deferDays: 'Defer {{days}}',
        deferred: 'Update deferred',
        importTitle: 'Import a package from USB',
        importHint: 'Folder path on the hotel server (contains manifest.json and bundle.tar.gz). Nothing installs until you press "Install now".',
        importPath: 'Package path',
        importButton: 'Import',
        imported: 'Package {{version}} imported',
        started: 'Install started. Follow the state here.',
        runs: 'Update history',
        states: {
            idle: 'idle',
            detected: 'detected',
            verifying: 'verifying',
            scheduled: 'scheduled',
            downloading: 'downloading',
            verified: 'verified',
            preflight: 'preflight',
            backing_up: 'backing up',
            migrating: 'migrating',
            switching: 'switching',
            health_check: 'health check',
            done: 'done',
            rolled_back: 'rolled back',
            failed: 'failed',
            incompatible: 'incompatible',
        },
        banner: {
            available: 'Update {{version}} is ready. It installs in the maintenance window or when you choose.',
            inProgress: 'System update in progress (~5 min). Do not power off the server.',
            rolledBack: 'The update failed and the system returned to the previous version. Work continues. Support was notified.',
        },
        sync: {
            ok: 'synced',
            delayed: 'sync delayed',
            offline: 'no cloud connection',
            unknown: 'not activated',
            pending: '{{n}} events awaiting sync',
        },
    },
    errors: {
        licenseRestricted: 'This action is restricted by the license state. Check-out, payments and export always work.',
        roomCapReached: 'The licensed room cap is reached. Contact Syrova to raise it.',
        licenseSignature: 'License signature invalid or key not trusted.',
        licenseMismatch: 'This license belongs to another property or device.',
        licenseOlder: 'A newer license is already applied.',
        nodeIdentityMissing: 'The device identity does not exist yet (is the node agent running?).',
        storageFull: 'The server disk is full. Nothing was saved. Free space and retry (RB-03).',
        dbUnavailable: 'The database is unavailable right now (it may be restarting). Retry in a moment.',
        agentUnavailable: 'The node agent is not responding. Check the syrova-agent service.',
        agentBusy: 'The agent is running another job. Wait for it to finish.',
        generic: 'Unexpected error. Retry or contact support.',
        forbidden: 'You do not have permission for this action',
        conflict: 'This record was changed by another user. Reload.',
        validation: 'Check the highlighted fields',
        noAvailability: 'No availability for the requested room type on these nights',
        overbookingConfirm: 'This booking exceeds available inventory. Confirming needs the overbooking permission.',
        roomConflict: 'The room is booked on these nights',
        roomNotReady: 'Room is not ready (dirty)',
        roomNotAssigned: 'Assign a room first',
        identityRequired: 'An identity document is required before check-in',
        possibleDuplicate: 'A similar guest exists',
        noRate: 'No rate defined for these nights',
        creditLimit: 'Credit limit exceeded for the company account; override with a reason or take payment',
        arSuspended: 'The company account is suspended; the guest pays directly',
        groupFull: 'No blocked rooms left for this type; raise the block first',
        groupBelowPickup: 'The block cannot drop below the picked-up count',
        shiftRequired: 'Open a cashier shift first',
        channelRatePlan: 'No channel rate plan is set in the channel settings',
    },
    search: {
        placeholder: 'Search: guest, room, confirmation, phone… (Ctrl+K)',
        commands: 'Commands',
        guestsGroup: 'Guests',
        reservationsGroup: 'Reservations',
        inHouseGroup: 'In-house',
        hint: '↑↓ to move, Enter to open, Esc to close',
    },
    shortcuts: {
        title: 'Keyboard shortcuts',
        search: 'Global search',
        help: 'This panel',
        goDashboard: 'Dashboard',
        goArrivals: 'Arrivals',
        goDepartures: 'Departures',
        goInHouse: 'In-house',
        goReservations: 'Reservations',
        goTape: 'Tape chart',
        goCashier: 'Cashier',
        goNightAudit: 'Night audit',
        goHousekeeping: 'Housekeeping',
        goGuests: 'Guests',
        newItem: 'New item',
        walkIn: 'Walk-in',
        openSelected: 'Open selected',
        submit: 'Save / confirm',
        closeDialog: 'Close',
        lock: 'Lock screen',
    },
    dashboard: {
        arrivalsToday: 'Arrivals today',
        departuresToday: 'Departures today',
        inHouseNow: 'In-house now',
        occupancy: 'Occupancy',
        dirtyRooms: 'Dirty rooms',
        pendingArrivals: 'Pending arrivals',
    },
    room: {
        room: 'Room',
        rooms: 'Rooms',
        number: 'Room number',
        type: 'Room type',
        floor: 'Floor',
        status: 'Room status',
        dirty: 'Dirty',
        clean: 'Clean',
        inspected: 'Inspected',
        ooo: 'Out of order',
        oos: 'Out of service',
        occupied: 'Occupied',
        vacant: 'Vacant',
        unassigned: 'Unassigned',
        pickRoom: 'Pick a room',
        noCandidates: 'No rooms of this type are free for the period',
        markClean: 'Mark clean',
        markDirty: 'Mark dirty',
    },
    guest: {
        fatherName: "Father's name",
        motherName: "Mother's name",
        birthPlace: 'Place of birth',
        scan: {
            button: 'Read from ID photo',
            reading: 'Reading the photo…',
            done: 'ID read: review the fields before saving.',
            check: 'Check especially: {{fields}}',
            failed: 'No card found in the photo. Photograph the whole front of the ID on a dark surface, or type the details.',
            error: 'Reading is not available on this computer. Type the details.',
            birthDate: 'Date of birth',
            nationalNumber: 'National number',
        },
        dangerZone: 'Danger zone',
        documentsHint: 'Document numbers are stored encrypted; every view is logged.',
        anonymize: 'Erase personal data (anonymise)',
        anonymizeReason: 'Reason',
        anonymizeConfirm: 'The name is replaced and phone, email and documents are erased for good; invoices stay. Continue?',
        anonymized: 'Profile anonymised',
        anonymizeScheduled: 'Anonymisation scheduled for {{date}} because of the financial retention floor',
        anonymizedBadge: 'anonymised',
        guest: 'Guest',
        guests: 'Guests',
        profile: 'Guest profile',
        nameAr: 'Name (Arabic)',
        nameLatin: 'Name (Latin)',
        phone: 'Phone',
        email: 'Email',
        nationality: 'Nationality',
        dateOfBirth: 'Date of birth',
        gender: 'Gender',
        male: 'Male',
        female: 'Female',
        vip: 'VIP',
        blacklisted: 'Blacklisted',
        newGuest: 'New guest',
        createQuick: 'Create guest “{{name}}”',
        typeToSearch: 'Type at least 2 characters to search',
        duplicateHint: 'Similar guests exist. Pick one or confirm creation.',
        createAnyway: 'Create anyway',
        identity: 'Identity document',
        documents: 'Documents',
        addDocument: 'Add document',
        docType: 'Document type',
        docNumber: 'Document number',
        issuingCountry: 'Issuing country',
        issueDate: 'Issue date',
        expiryDate: 'Expiry date',
        passport: 'Passport',
        nationalId: 'National ID',
        drivingLicense: 'Driving licence',
        residencePermit: 'Residence permit',
        other: 'Other',
        reveal: 'Reveal number',
        revealReason: 'Reason for access',
        encryptedHint: 'Document numbers are stored encrypted and every access is logged',
        noDocuments: 'No documents on file',
        stays: 'Stays',
    },
    reservation: {
        reservation: 'Reservation',
        reservations: 'Reservations',
        confirmation: 'Confirmation #',
        status: 'Status',
        arrival: 'Arrival',
        departure: 'Departure',
        source: 'Source',
        ratePlan: 'Rate plan',
        needGuest: 'Pick or create a guest to continue',
        guarantee: 'Guarantee',
        tentative: 'Tentative',
        confirmed: 'Confirmed',
        checked_in: 'In-house',
        checked_out: 'Checked out',
        cancelled: 'Cancelled',
        no_show: 'No-show',
        moved: 'Moved',
        requested: 'Booking request',
        roomsSection: 'Dates & rooms',
        guestSection: 'Guest',
        rateSection: 'Rate & guarantee',
        notesSection: 'Notes',
        addRoomLine: 'Add room',
        removeRoomLine: 'Remove',
        availability: 'Available',
        quote: 'Quote',
        perNight: 'per night',
        createTentative: 'Tentative (auto-released after the hold)',
        allowOverbooking: 'Allow overbooking (permission)',
        create: 'Create reservation',
        created: 'Reservation {{number}} created',
        walkInMode: 'Walk-in mode: arrival is today and check-in follows immediately',
        sources: {
            walk_in: 'Walk-in',
            phone: 'Phone',
            email: 'Email',
            whatsapp: 'WhatsApp',
            website: 'Website',
            ota: 'OTA',
            travel_agent: 'Travel agent',
            corporate: 'Corporate',
            channel: 'Online channel',
            other: 'Other',
        },
        guarantees: {
            none: 'None',
            deposit: 'Deposit',
            company: 'Company',
            credit_card: 'Card (reference)',
        },
        assign: 'Assign room',
        assignAuto: 'Auto-assign rooms',
        unassign: 'Unassign',
        checkIn: 'Check in',
        checkOut: 'Check out',
        cancelReservation: 'Cancel reservation',
        reinstate: 'Reinstate',
        noShow: 'No-show',
        extend: 'Extend / shorten',
        move: 'Room move',
        undoCheckIn: 'Undo check-in',
        printConfirmation: 'Print confirmation',
        cancelled_ok: 'Reservation cancelled',
        timeline: 'Timeline',
        searchPlaceholder: 'Name, confirmation #, phone…',
        allStatuses: 'All statuses',
        overbookingWarning: 'Warning: this booking exceeds inventory',
        holdExpires: 'Hold expires at',
    },
    checkin: {
        title: 'Check-in',
        summary: 'Reservation summary',
        room: 'Room',
        identity: 'Identity',
        identityOk: 'Document on file',
        identityMissing: 'No document on file',
        allowDirty: 'Allow a dirty room (supervisor permission)',
        allowIdentityPending: 'Check in with identity pending (supervisor permission)',
        allowBeforeArrival: 'Early check-in before arrival date (permission)',
        confirm: 'Confirm check-in',
        done: 'Checked in to room {{room}}',
        printCard: 'Print registration card',
        registrationCard: 'Registration card',
        guestsOnStay: 'Guests in the room',
        sign: 'Guest signature',
        signed: 'Card signed ✓',
        signTitle: 'Guest signature on the registration card',
        signHint: 'The guest signs here with a finger, pen or mouse',
        signClear: 'Clear',
        signSave: 'Save signature',
        signDone: 'Guest signature saved',
        signTerms: 'By signing, the guest confirms the registration card details and accepts the terms of stay.',
    },
    stay: {
        newDeparture: 'New departure',
        extendHint: 'Added nights are priced with the current rate plan',
        moveTo: 'To room',
        moveReason: 'Move reason',
        reprice: 'Apply the new room’s rate',
        moved: 'Moved to room {{room}}',
        extended: 'Departure changed to {{date}}',
    },
    reasons: {
        guest_request: 'Guest request',
        price: 'Price',
        duplicate: 'Duplicate booking',
        error: 'Input error',
        operational: 'Operational',
        other: 'Other',
    },
    tape: {
        allTypes: 'All types',
        filterType: 'Room type',
        weeks: 'week',
        title: 'Tape chart',
        days: 'days',
        legend: 'Legend',
        unassigned: 'Unassigned reservations',
        clickHint: 'Click an empty cell for a new reservation, or a booking to open it',
    },
    billing: {
        folio: 'Folio',
        folios: 'Folios',
        window: 'Window',
        balance: 'Balance',
        credit: 'Credit balance',
        lines: 'Lines',
        uninvoicedLines: 'Uninvoiced lines: {{n}}',
        line: 'Line',
        lineNo: '#',
        description: 'Description',
        amount: 'Amount',
        original: 'Original',
        base: 'In base currency',
        postedBy: 'By',
        postedAt: 'Posted at',
        businessDate: 'Business date',
        reversed: 'Reversed',
        reversal: 'Reversal',
        active: 'Active',
        invoiced: 'Invoiced',
        open: 'Open',
        settled: 'Settled',
        closed: 'Closed',
        postCharge: 'Post charge',
        chargeCode: 'Charge code',
        quantity: 'Quantity',
        unitPrice: 'Unit price',
        currency: 'Currency',
        takePayment: 'Take payment',
        deposit: 'Deposit',
        payment: 'Payment',
        method: 'Method',
        methods: { cash: 'Cash', card: 'Card', bank_transfer: 'Bank transfer', other: 'Other' },
        tenderCurrency: 'Tender currency',
        received: 'Amount received',
        changeCurrency: 'Change currency',
        changeDue: 'Change due',
        rateApplied: 'Exchange rate applied',
        equivalent: 'Equivalent',
        remaining: 'Remaining after payment',
        methodDetail: 'Reference (transaction no.)',
        receivedFrom: 'Received from',
        receipt: 'Receipt',
        receiptNo: 'Receipt no.',
        refund: 'Refund',
        requestRefund: 'Request refund',
        refundPending: 'Refund awaits a supervisor approval',
        refundPosted: 'Refund posted — receipt {{receipt}}',
        discount: 'Discount',
        postDiscount: 'Discount on line',
        percent: 'Percent %',
        discountPending: 'Discount awaits a supervisor approval',
        reverse: 'Reverse line',
        reverseConfirm: 'A reversal line with the opposite sign will be added (nothing is deleted).',
        transfer: 'Transfer to window',
        transferTo: 'Target window',
        newWindow: 'New window',
        ownerLabel: 'Window name',
        ownerType: 'Owner',
        owners: { guest: 'Guest', company: 'Company', house: 'House' },
        closeFolio: 'Close folio',
        invoice: 'Invoice',
        proforma: 'Proforma',
        issueFinal: 'Issue final invoice',
        issueProforma: 'Proforma (no final number)',
        issueConfirm: 'A sequential number will be allocated; it can only be cancelled by a credit note.',
        billTo: 'Bill to',
        taxId: 'Tax ID',
        invoices: 'Invoices',
        creditNote: 'Credit note',
        creditNoteFull: 'Full credit note (cancel invoice)',
        invoiceStatus: {
            proforma: 'Proforma',
            issued: 'Issued',
            partially_credited: 'Partially credited',
            fully_credited: 'Cancelled by credit note',
        },
        totalNet: 'Net',
        serviceCharge: 'Service charge',
        tax: 'Tax',
        totalGross: 'Total',
        paid: 'Paid',
        due: 'Due',
        selectLine: 'Select a line first',
        checkOut: 'Check out',
        checkOutConfirm: 'The folio will be closed and the room released (dirty).',
        earlyDeparture: 'Departing before the expected date — confirm shortening',
        balanceNotZero: 'Settle the balance before check-out',
        checkedOut: 'Checked out',
        reopenStay: 'Reopen stay',
        pinTitle: 'Confirm with PIN',
        pinHint: 'Financial actions require PIN re-authentication',
        noShift: 'No open shift — open a shift first',
        openShiftLink: 'Open shift',
        postDeparture: 'Post-departure',
    },
    cashier: {
        closedBySupervisor: 'Closed by a supervisor',
        reopenCount: 'Reopened: {{n}}',
        title: 'Cashier',
        shift: 'Shift',
        noShift: 'No open shift',
        openShift: 'Open shift',
        closeShift: 'Close shift',
        openingFloat: 'Opening float',
        addCurrency: 'Add currency',
        blindCount: 'Blind count',
        blindHint: 'Enter the counted cash per currency; expected is revealed after submission.',
        counted: 'Counted',
        expected: 'Expected',
        variance: 'Variance',
        varianceReason: 'Variance reason',
        varianceReasonRequired: 'Variance exceeds tolerance — a reason is required',
        closed: 'Shift closed',
        opened: 'Shift opened',
        reopen: 'Reopen',
        byMethod: 'By payment method',
        shifts: 'Shifts',
        status: { open: 'Open', closing: 'Closing', closed: 'Closed', carried: 'Carried' },
        report: 'Shift report',
        approvals: 'Approvals',
        pending: 'Pending',
        approve: 'Approve',
        reject: 'Reject',
        requestedBy: 'Requested by',
        decidedBy: 'Decided by',
        kinds: { refund: 'Refund', discount: 'Discount', shift_reopen: 'Shift reopen' },
        decided: 'Decision recorded',
        user: 'User',
    },
    audit: {
        run: 'Audit progress',
        title: 'Night audit',
        history: 'Run history',
        businessDate: 'Current business date',
        nextDate: 'New business date',
        prechecks: 'Pre-checks',
        checks: {
            'PC-01': 'Departures not checked out',
            'PC-02': 'Unhandled arrivals (processed as no-shows)',
            'PC-03': 'Open cashier shifts',
            'PC-04': 'Pending approvals',
            'PC-05': 'Currencies without an exchange rate',
        },
        override: 'Override with reason',
        overridden: 'Overridden',
        start: 'Start night audit',
        startConfirm: 'Business date {{date}} will be closed and advanced to {{next}}. This cannot be undone.',
        resume: 'Resume',
        blocked: 'Blocked — resolve or override the items',
        running: 'Running…',
        failed: 'Failed',
        completed: 'Completed',
        completed_with_overrides: 'Completed with overrides',
        steps: {
            'NA-01': 'Pre-checks',
            'NA-02': 'Post room charges and taxes',
            'NA-03': 'Process no-shows',
            'NA-04': 'Shifts and approvals',
            'NA-05': 'Freeze the day and roll the date',
            'NA-06': 'Roll housekeeping and maintenance to the new day',
            'NA-07': 'Report pack',
            'NA-08': 'Close and backup',
        },
        counters: {
            roomChargesPosted: 'Room charges posted',
            roomChargesSkipped: 'Already posted',
            noShows: 'No-shows',
            depositForfeits: 'Deposits forfeited',
            shiftsCarried: 'Shifts carried',
            approvalsExpired: 'Approvals expired',
            staysAutoExtended: 'Stays auto-extended',
            hkRoomsReset: 'Rooms reset to dirty',
            hkDeparture: 'Departure tasks',
            hkStayover: 'Stayover tasks',
            hkVacantDirty: 'Vacant-dirty tasks',
            oooActivated: 'Rooms taken out of order',
            oooEnded: 'Rooms back in service',
        },
        printPack: 'Print audit pack',
        adminRollover: 'Administrative date rollover (no postings)',
        noActive: 'No active run',
        done: 'Night audit completed — new business date {{date}}',
    },
    reports: {
        title: 'Reports',
        dailyPack: 'Daily pack',
        ownerSummary: {
            button: 'Owner summary on WhatsApp',
            title: 'Owner summary on WhatsApp',
            hint: 'WhatsApp opens on this computer with the message ready; review it and press send there.',
            phone: "Owner's WhatsApp number",
            phoneHint: 'International format without +, e.g. 963933123456; remembered for next time. Leave empty to pick the chat by hand.',
            text: 'Message',
            open: 'Open WhatsApp',
        },
        source: { snapshot: 'Audit snapshot', live: 'Live' },
        flash: 'Manager flash',
        roomsSold: 'Rooms sold',
        occupancy: 'Occupancy',
        adr: 'ADR',
        revpar: 'RevPAR',
        roomRevenue: 'Room revenue',
        revenueJournal: 'Daily revenue journal',
        reconciled: 'Reconciled',
        notReconciled: 'Not reconciled',
        payments: 'Payments by method',
        shifts: 'Shifts',
        deposits: 'Deposits',
        exceptions: 'Refunds, reversals and discounts',
        invoices: 'Invoices and credit notes',
        gaps: 'Gaps',
        noShows: 'No-shows and cancellations',
        openFolios: 'Open folios',
        rates: 'Exchange rates in effect',
        auditExceptions: 'Audit exceptions',
        taxes: 'Tax report',
        exportCsv: 'Export CSV',
        group: 'Group',
        count: 'Count',
    },
    hk: {
        title: 'Housekeeping',
        board: 'Room board',
        myTasks: 'My tasks',
        tasks: 'Tasks',
        task: 'Task',
        generate: "Generate today's tasks",
        generated: 'Tasks generated',
        distribute: 'Distribute tasks',
        assign: 'Assign',
        assignee: 'Attendant',
        unassigned: 'Unassigned',
        types: {
            departure: 'Departure',
            stayover: 'Stayover',
            vacant_dirty: 'Vacant dirty',
            manual: 'Manual',
        },
        status: {
            pending: 'Pending',
            in_progress: 'In progress',
            done: 'Done',
            rejected: 'Rejected',
            inspected: 'Inspected',
            cancelled: 'Cancelled',
            inspected_skipped: 'Inspection skipped',
        },
        start: 'Start',
        finish: 'Finish',
        inspectOk: 'Pass inspection',
        reject: 'Reject',
        rejectReason: 'Rejection reason',
        cancel: 'Cancel task',
        dnd: 'Do not disturb',
        returnLater: 'Return later',
        markDirty: 'Dirty',
        markClean: 'Clean',
        markInspected: 'Inspected',
        occupied: 'Occupied',
        vacant: 'Vacant',
        arriving: 'Arriving today',
        departing: 'Departing today',
        floor: 'Floor',
        allFloors: 'All floors',
        discrepancy: 'Discrepancy report',
        observed: 'Physical observation',
        observedOptions: {
            occupied: 'Occupied',
            vacant: 'Vacant',
            sleep_out: 'Sleep-out',
            skip: 'Skip',
        },
        kinds: {
            ok: 'Matches',
            possible_sleep_out: 'Possible sleep-out',
            unregistered_guest: 'Unregistered guest',
            skip: 'Skip',
        },
        resolve: 'Resolve',
        resolution: 'Resolution',
        reportIssue: 'Report an issue',
        newTask: 'New task',
        attendants: 'Attendants',
        saved: 'Saved',
        noTasks: 'No tasks',
        pickAttendants: 'Pick attendants to distribute to',
    },
    mnt: {
        startWork: 'Start work',
        title: 'Maintenance',
        tickets: 'Tickets',
        newTicket: 'New ticket',
        kind: 'Kind',
        kinds: {
            ticket: 'Ticket',
            out_of_order: 'Out of order (OOO)',
            out_of_service: 'Out of service (OOS)',
        },
        titleField: 'Title',
        location: 'Location (public area)',
        priority: 'Priority',
        priorities: { low: 'Low', normal: 'Normal', high: 'High', urgent: 'Urgent' },
        status: { open: 'Open', in_progress: 'In progress', resolved: 'Resolved', closed: 'Closed' },
        range: 'Date range',
        affected: 'Affected reservations',
        affectedHint: 'These reservations are assigned to the room within the range; confirming unassigns them.',
        unassignConfirm: 'Unassign the affected reservations and continue',
        resolve: 'Resolve ticket',
        resolutionNote: 'Resolution note',
        reporter: 'Reported by',
        report: 'Rooms out of order',
        lostNights: 'Lost nights',
        created: 'Ticket created',
        occupiedError: 'The room is occupied — move the guest first',
    },
    handover: {
        title: 'Shift handover',
        notes: 'Notes',
        newNote: 'New note',
        kind: 'Kind',
        kinds: { info: 'Info', follow_up: 'Follow-up', incident: 'Incident' },
        department: 'Department',
        departments: {
            front_office: 'Front office',
            housekeeping: 'Housekeeping',
            finance: 'Finance',
            maintenance: 'Maintenance',
            fnb: 'F&B',
            management: 'Management',
        },
        body: 'Text',
        acknowledge: 'Acknowledge',
        acknowledged: 'Acknowledged',
        close: 'Close',
        closeComment: 'Closing comment',
        pendingTitle: 'Notes awaiting your acknowledgement',
        pendingHint: 'Acknowledge every note before continuing.',
        summary: 'Handover summary',
        printSummary: 'Print handover summary',
        arrivalsRemaining: 'Arrivals remaining',
        departuresRemaining: 'Departures remaining',
        roomsNotReady: 'Rooms not ready',
        open: 'Open',
        closed: 'Closed',
        author: 'Author',
    },
    dash: {
        arrivals: 'Arrivals (expected/done)',
        departures: 'Departures (expected/done)',
        ready: 'Rooms ready',
        ooo: 'OOO / OOS',
        unassignedArrivals: 'Arrivals without a room',
        departuresWithBalance: 'Departures with balance',
        overdue: 'Overdue stays',
        tentativeExpiring: 'Tentative holds expiring',
        alerts: 'Alerts',
        overbooking: 'Overbooking {{code}} on {{night}} (+{{over}})',
        discrepancies: 'Housekeeping discrepancies: {{n}}',
        incidents: 'Open incidents: {{n}}',
        auditOverdue: 'Night audit not run: business date {{date}}, calendar {{today}}',
        revenueToday: "Today's revenue",
        noAlerts: 'No alerts',
    },
    auditLog: {
        title: 'Audit log',
        user: 'User',
        action: 'Action',
        entity: 'Entity',
        entityId: 'Id',
        before: 'Before',
        after: 'After',
        sensitiveOnly: 'Sensitive only',
        export: 'Export CSV',
        timeline: 'Timeline',
    },
    print: {
        paper: 'Paper on this computer',
        paperA4: 'A4',
        paper80: 'Thermal 80 mm',
        hotel: 'Hotel',
        registrationCard: 'Guest registration card',
        confirmation: 'Reservation confirmation',
        signature: 'Guest signature',
        receivedFrom: 'Received from',
        paidAt: 'Paid at',
        cashierSignature: 'Cashier signature',
        guestSignature: 'Guest signature',
        printedAt: 'Printed at',
        signedAt: 'Signed at',
        terms: 'By signing below the guest confirms the data above and accepts the terms of stay.',
    },
};
//# sourceMappingURL=en.js.map